import { firstLastName } from '../lib/person-name'
import { Avatar } from './PeoplePicker'

/**
 * A person as a pill: their round photo (initials when there is none — both handled by
 * {@link Avatar}), then their name as "First Last". The full directory name is the tooltip. The
 * photo is decoration — the name is the text a screen reader reads.
 */
export function PersonChip({
  email,
  displayName,
  size = 20,
}: {
  email: string
  displayName: string
  size?: number
}) {
  const name = firstLastName(displayName) || email

  return (
    <span className="person-chip" title={displayName || email}>
      <Avatar email={email} displayName={name} size={size} />
      <span className="person-chip-name">{name}</span>
    </span>
  )
}
